<template>
  <div class="p-1 row row-cols-5 align-items-center containerSelect">
    <div class="col p-1 mx-1" :class="{ 'active': model.data.date }">
      <label class="d-flex align-items-center column">
      <input type="checkbox" v-model="model.data.date" />
        <img :src="require(`@/assets/images/icons/template-builder/date-time.svg`)" alt="Icon" class="iconStyle"/>
        {{ $t("maintenance.date") }}
      </label>
    </div>
    <div class="col p-1 mx-1" :class="{ 'active': model.data.time }">
      <label class="d-flex align-items-center column">
      <input type="checkbox" v-model="model.data.time" />
        <img :src="require(`@/assets/images/icons/template-builder/time.svg`)" alt="Icon" class="iconStyle"/>
        {{ $t("maintenance.time") }}
      </label>
    </div>
  </div>
</template>

<script>
const TYPE = "date_time";
const MODEL = {
  data: {
    date: true,
    time: true,
    valid: true,
  },
};

export default {
  props: {
    data: Object,
    config: Object,
  },
  data() {
    return {
      model: MODEL,
    };
  },
  created() {
    const isDataEmpty = JSON.stringify(this.data.data) === "{}";
    this.model = this.data;

    if (isDataEmpty) {
      this.model = MODEL;
    } else if (!isDataEmpty && TYPE !== this.config.type) {
      this.model = MODEL;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>

input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: .4rem;
}
.containerSelect :hover {
  background-color: #cce8ff;
  color: #1b3d5e;
  border-radius: 5px;
}

.iconStyle {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.active {
  background-color: #cce8ff;
  color: #1b3d5e;
  border-radius: 5px;
}

.dark-layout {
  .active span {
    color: #1b3d5e;
  }
}
</style>
